import {FC, useEffect} from "react";
import {Grid, TextField, Tooltip} from "@material-ui/core";
import * as React from "react";
import {AkamaiTokenData} from "./types/akamaiTokenData";


interface Props {
    verizon_token: AkamaiTokenData;
    verizon_key : string ;
    window : string;
    verizon_protocol;
}

const VerizonToken : FC<Props> = ({verizon_token , verizon_key , window, verizon_protocol}) => {

    const [key , setKey] = React.useState<any>('');
    const [protocol , setProtocol] = React.useState<any>('');
    const [verizon_window , setWindow] = React.useState<any>('');

    useEffect( ()=> {
        verizon_token(JSON.stringify({"key" : key ,"proto_allowed" : protocol , "window" : verizon_window}))
    },[key,protocol,verizon_window])

    useEffect(() => {
        if (verizon_key && window){
            setKey(verizon_key)
            setProtocol(verizon_protocol)
            setWindow(window)
        }

    }, [verizon_key,verizon_protocol, window])

    return(
        <>
            <Grid item md={3}>
                <Tooltip title="The key needed to generate the akamai token for stream protection" placement='top-end' aria-multiline>
                    <TextField
                        placeholder="Verizon Key"
                        variant="outlined"
                        name="key"
                        value={verizon_key}
                        fullWidth
                        onChange={e => {setKey(e.target.value)}}
                    />
                </Tooltip>
            </Grid>
            <Grid item md={3}>
                <Tooltip title="Time in minutes of validity" placement='top-end' aria-multiline>
                    <TextField
                        placeholder="Protocol allowed"
                        variant="outlined"
                        name='proto_allowed'
                        value={verizon_protocol}
                        fullWidth
                        onChange={e => {setProtocol(e.target.value)}}
                    />
                </Tooltip>
            </Grid>
            <Grid item md={3}>
                <Tooltip title="Time in minutes of validity" placement='top-end' aria-multiline>
                    <TextField
                        placeholder="Window"
                        variant="outlined"
                        name='window'
                        value={window}
                        fullWidth
                        onChange={e => {setWindow(e.target.value)}}
                    />
                </Tooltip>
            </Grid>
        </>

    )
}




export default VerizonToken;